module.exports = __webpack_public_path__ + "static/media/working.855fdacd.svg";